@defer (when !isLoading()) {
  <p>Loaded specs!</p>
} @placeholder {
  <plp-components-skeleton-specs-section>
  </plp-components-skeleton-specs-section>
}
